/**
 * 参会者编辑器
 *
 */

'use strict'

import Vue from 'vue';
import Component from "vue-class-component";
import { iStorage, iValidator } from 'smart-core-util';
@Component
class attenderEditor extends Vue {

	keyword = "";
	hospitalName = "";
	section = "";
	outerList = [];
	innerList = [];
	tableData = [];
	pageIndex = 1;
	pageSize = 10;
	total = null;

	get proposalId() {
		return iStorage.get("proposalId");
	}

	async created() {

	}

	//获取外部参会人、签到
	async HcpInfoPagingByMarker(type) {
		var params = {
			marker: this.keyword,
			pageIndex: this.pageIndex,
			pageSize: this.pageSize,
			noCount: false,
			miceId: this.proposalId,
			source: this.$route.query.source || '' //添加签到人员，需要过滤已签到的人员
		};
		if(this.$route.query.attendeeTitle == 'HCP（CRM客户）' || type == 'web'){
			params.hospitalName = this.hospitalName;
			params.section = this.section;
			// params.pageSize = 1000
		}
		var response = null
		if(this.$route.query.addCommonAttendee || this.$route.path == '/SlectCommonAttendee') {
			response = await this.api.post(this.url.mice.HcpInfoPagingOftenAttender, params);
		}else{
			response = await this.api.post(this.url.mice.HcpInfoPagingByMarker, params);
		}
		if(response && response.success) {
			if(type == 'web'){
				return response.content;
			}
			this.loading = false;
			if(this.pageIndex == 1) {
				this.outerList = []
			}
			this.outerList = this.outerList.concat(response.content.rows);
			if(this.outerList.length == response.content.total) {
				this.allLoaded = true;
			}
			this.outerList.map(ele => {
				if(ele.hospitalData) {
					ele.hospitalData = JSON.parse(ele.hospitalData);
				}
				ele.inviteEmail = ele.email
				ele.invitePhone = ele.phoneNumber
			});
			this.isFullscreen();
		}
	}

	//获取内部参会人、签到
	async EmployeePagingByMarker(type) {
		var params = {
			marker: this.keyword,
			pageIndex: this.pageIndex,
			pageSize: this.pageSize,
			noCount: false,
			miceId: this.proposalId,
			source: this.$route.query.source || '' //添加签到人员，需要过滤已签到的人员
		};
		var response = null
		// if(type == 'web'){
		//     params.pageSize = 1000
		// }
		if(this.$route.query.addCommonAttendee || this.$route.path == '/SlectCommonAttendee') {
			response = await this.api.post(this.url.mice.EmployeePagingOftenAttender, params);
		}else{
			response = await this.api.post(this.url.mice.EmployeePagingByMarker, params);
		}
		if(response && response.success) {
			if(type == 'web'){
				return response.content;
			}
			this.loading = false;
			if(this.pageIndex == 1) {
				this.innerList = [];
			}
			this.innerList = this.innerList.concat(response.content.rows);
			if(this.innerList.length == response.content.total) {
				this.allLoaded = true;
			}
			this.innerList.map(ele => {
				ele.inviteEmail = ele.email
				ele.invitePhone = ele.mobile
			});
			this.isFullscreen();
		}
	}

	//保存
	async AttenderSave(item,type) {
		if(type == 'web'){
			for(var i=0;i<item.length;i++){
				item[i].miceId = this.proposalId;
				item[i].extId = item[i].hcpId || item[i].employeeId;
				// item[i].attenderType =  this.tabActiveName == "outer" ? 1 : 2;
				item[i].inviteStatus = 0;
				item[i].inviteEmail = "";
				item[i].isSended = false;
				delete item[i].attenderId
			}
			var response = await this.api.post(this.url.mice.BatchSave, item);
			if(response && response.success) {
				return response
//				onSuccess(response);
			}
			return false;
		}
		var params = {
			miceId: this.proposalId,
			extId: this.$route.query.attendeeTitle == "HCP（CRM客户）" ? item.hcpId : item.employeeId,
			attenderType: this.$route.query.attendeeTitle == "HCP（CRM客户）" ? 1 : 2,
			inviteStatus: 0,
			inviteEmail: item.inviteEmail,
			invitePhone: item.invitePhone,
			isSended: false,
			isNeedCheckIn: true
		};
		var response = null
		if(this.$route.path == '/SlectCommonAttendee' && this.selected == 'outer') {
			params.extId = item.extId
			params.attenderType = 1
		}
		if(this.$route.path == '/SlectCommonAttendee' && this.selected == 'inner') {
			params.extId = item.extId
			params.attenderType = 2
		}
		if(this.$route.query.addCommonAttendee) {
			params = {
				userId: this.iStorage.get("userId"),
				extId: this.$route.query.attendeeTitle == "HCP（CRM客户）" ? item.hcpId : item.employeeId,
				attenderType: this.$route.query.attendeeTitle == "HCP（CRM客户）" ? 1 : 2,
				miceType: 1
			};
			response = await this.api.post(this.url.userOftenAttender.Save, params);
		}else{
			response = await this.api.post(this.url.mice.AttenderSave, params);
		}
		if(response && response.success) {
			if(this.$route.path == '/SlectCommonAttendee') {
				return true
			}
			item.isChecked = true;
			item.attenderId = response.content;
		}
	}

	//删除
	async AttenderDelete(item,type) {
		var params = this.$route.query.attendeeTitle == "HCP（CRM客户）" ? {
			miceId:this.iStorage.get('proposalId'),
			extId: item.hcpId,
			attenderType: '1'
		} : {
			miceId:this.iStorage.get('proposalId'),
			extId: item.employeeId,
			attenderType: '2'
		};
		params.miceId = this.proposalId
		if(this.$route.path == '/SlectCommonAttendee' && this.selected == 'outer') {
			params.extId = item.extId
			params.attenderType = 1
			params.miceId = this.proposalId
		}
		if(this.$route.path == '/SlectCommonAttendee' && this.selected == 'inner') {
			params.extId = item.extId
			params.attenderType = 2
			params.miceId = this.proposalId
		}
		var response = null
		if(this.$route.query.addCommonAttendee) {
			params.attenderType = this.$route.query.attendeeTitle == "HCP（CRM客户）" ? 1 : 2
			params.userId = this.iStorage.get("userId")
			response = await this.api.post(this.url.userOftenAttender.Remove, params);
		}else{
			let params = {
				attenderId: item.attenderId
			}
			response = await this.api.post(this.url.mice.AttenderDelete, params);
		}
		if(response && response.success) {
			if(this.$route.path == '/SlectCommonAttendee') {
				return true
			}
			item.isChecked = false;
		}
	}

}

export default attenderEditor;



// WEBPACK FOOTER //
// ../scripts/components/attenderEditor.js